export default "__VITE_ASSET__6b8cb3ad__"